import { ArrowRight } from "lucide-react";
import Link from "next/link";

import { darkGradient } from "./ctaButtonStyles";

export interface HubLinkItem {
  href: string;
  title: string;
  description: string;
}

export interface HubLinkListCopy {
  id: string;
  eyebrow: string;
  heading: string;
  intro: string;
  items: HubLinkItem[];
}

export function HubLinkList({
  copy,
  className = "bg-background-light",
}: {
  copy: HubLinkListCopy;
  className?: string;
}) {
  return (
    <section id={copy.id} className={`py-24 ${className}`}>
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="max-w-3xl mb-12">
          <h2
            className="text-sm font-semibold bg-clip-text text-transparent uppercase tracking-widest mb-3"
            style={{ backgroundImage: darkGradient }}
          >
            {copy.eyebrow}
          </h2>
          <h3 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-6">
            {copy.heading}
          </h3>
          <p className="text-lg text-slate-600">{copy.intro}</p>
        </div>

        <ul className="space-y-6">
          {copy.items.map(item => (
            <li key={item.href}>
              <Link
                href={item.href}
                className="group block bg-white rounded-2xl p-6 md:p-8 border border-slate-100 hover:border-slate-200 hover:shadow-sm transition-shadow"
              >
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h4 className="text-xl font-semibold text-slate-900 mb-2 group-hover:text-slate-700">
                      {item.title}
                    </h4>
                    <p className="text-slate-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                  <ArrowRight
                    size={20}
                    className="flex-shrink-0 mt-1 text-slate-400 group-hover:text-slate-700 transition-colors"
                  />
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
